<template>
    <vue-modal :open="open">
        <div v-if="draftCreated === false && error === false">
            <div class="bax-icon bax-draft d-flex align-items-center justify-content-center">
                <i class="icon-save"></i>
            </div>
            <h2>Save order as draft?</h2>
            <p>You will be able to access your draft from the manage orders section</p>
            <div class="bax-modal-action-items">
                <ul class="d-md-flex justify-content-center">
                    <li>
                        <vue-button color="default" @click="goBack">Go back</vue-button>
                    </li>
                    <li>
                        <vue-button color="primary" @click="createDraftOrder">Create draft</vue-button>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="draftCreated === true">
            <div class="bax-icon bax-success d-flex align-items-center justify-content-center">
                <i class="icon-tick"></i>
            </div>
            <h2>Draft Created</h2>
            <p>{{ message }}</p>
            <div class="bax-modal-action-items">
                <ul class="d-md-flex justify-content-center">
                    <li>
                        <vue-button color="default" @click="goBack">Close</vue-button>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="error === true">
            <div class="bax-icon d-flex align-items-center justify-content-center">
                <i class="icon-cancel"></i>
            </div>
            <h2>Draft Failed</h2>
            <p>{{ message }}</p>
            <div class="bax-modal-action-items">
                <ul class="d-md-flex justify-content-center">
                    <li>
                        <vue-button color="default" @click="goBack">Close</vue-button>
                    </li>
                </ul>
            </div>
        </div>
    </vue-modal>
</template>

<script>
import OrderService from '@/core/api/order/order.service';

export default {
    name: 'DraftOrderModal',
    props: {
        open: {
            type: Boolean,
        },
    },
    data() {
        return {
            draftCreated: false,
            error: false,
            message: '',
        };
    },
    watch: {
        open(val) {
            if (val) {
                this.draftCreated = false;
                this.error = false;
                this.message = '';
            }
        },
    },
    created() {
      this.createDraftOrder();
    },
    methods: {
        goBack() {
            this.draftCreated = false;
            this.$emit('cancel');
        },
        createDraftOrder() {
            OrderService.submitDraftOrder({
                orderRef: this.$route.params.orderId,
            })
                .then((res) => {
                    this.draftCreated = true;
                    this.error = false;
                    this.message = res.data.message;
                })
                .catch((err) => {
                    this.draftCreated = false;
                    this.error = true;
                    this.message = err.response.data.message;
                });
        },
    },
};
</script>
